import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import Menumain from '../partils/menus/menumain';
import Menumobile from '../partils/menus/menumobile'
import axios from 'axios';
// DATA -------------------------------------------------------------------------

//https://api.unsplash.com/photos/?client_id=YOUR_ACCESS_KEY
//QLBGRA5h0l_koAVhav0Iot98kr161srcv7zbZVxdtCk

function Painel() {
    const [loading,setLoading]=useState(false)
    const [imgU, setImgU]=useState()
    const fetchApiButton = async()=>{
        const response = await axios.get('https://api.unsplash.com/photos/?client_id=QLBGRA5h0l_koAVhav0Iot98kr161srcv7zbZVxdtCk')
        console.log(response.data[0].urls.small)
        const data =await response.data;
        setImgU(response.data[2].urls.small)
    }

    
    
    
  return(
    <div className='w100 h100 b33 row around celular '>
      <label>teste</label>
      <button onClick={fetchApiButton}>Buscar</button>
      <img src={imgU}/>

     
      
      
        <Menumobile/>
   
    </div>
    
  )

}

export default Painel;